import React from 'react';
import './AssetsGallery.css';

function AssetsGalleryEn() {
  const galleryItems = [
    { id: 1, image: 'gallery-1.jpg', title: 'Technology University in Berlin, Germany.', caption: 'Two buildings of 7 thousand and 11 thousand square meters, both leased to two technology universities in Berlin.' },
    { id: 2, image: 'gallery-2.jpg', title: 'Residential Development in Mallorca, Spain.', caption: 'Residential development of 18 homes, 47 parking spaces and 18 storage rooms located on the island of Mallorca.' },
    { id: 3, image: 'gallery-3.jpg', title: 'Office Building in Charleroi, Belgium.', caption: 'Office building of 4,150 square meters located in Charleroi, Belgium. Co-investment with the Benou Fund.' },
    { id: 4, image: 'gallery-4.jpg', title: 'Office Building in Berlin, Germany.', caption: 'Office building of 6,400 square meters located in Berlin, Germany.' },
    { id: 5, image: 'gallery-5.jpg', title: 'Commercial Complex in Miami, Florida.', caption: 'Commercial complex of 32 stores located in Miami, Florida.' },
    { id: 6, image: 'gallery-6.jpg', title: 'Residential Building in Menorca, Spain.', caption: 'Residential building with 6 homes and a commercial premises located on the island of Menorca.' },
    { id: 7, image: 'gallery-7.jpg', title: 'Residential Building in Gamla Stan, Sweden.', caption: 'Luxury residential building with 9 homes and a store located in Gamla Stan, Sweden.' },
    { id: 8, image: 'gallery-8.jpg', title: 'Tourist Development in Mallorca, Spain.', caption: 'Tourist development of 52 holiday apartments located on the island of Mallorca. Participated project.' },
    { id: 9, image: 'gallery-9.jpg', title: 'Hotel in Hamelin, Germany.', caption: '4-star hotel with 98 rooms, spa and gym, located in Hamelin, Germany. Currently managed by a German group company.' },
    { id: 10, image: 'gallery-10.jpg', title: 'Housing in Palma de Mallorca, Spain.', caption: 'Renovated 80m2 house with two bedrooms in the heart of Palma de Mallorca. Currently leased.' },
    { id: 11, image: 'gallery-11.jpg', title: 'Land in Mahón, Menorca.', caption: 'Rural land with a project for the construction of a single-family home in the area.' }
  ];

  return (
    <section className="assets-gallery-section">
      <div className="container">
        <p className="assets-intro-text">
          At Tabia Group, we are proud to play a key role as an economic driver for the companies that make up our portfolio. Our focus is on identifying, investing in and enhancing the value of exceptional projects.
        </p>
        <div className="gallery-grid">
          {galleryItems.map((item) => (
            <div key={item.id} className="gallery-item">
              <div className="gallery-image-wrapper">
                <img src={`${process.env.PUBLIC_URL}/${item.image}`} alt={item.title} />
              </div>
              <h4 className="gallery-title">{item.title}</h4>
              <p className="gallery-caption">{item.caption}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AssetsGalleryEn;
